module.exports = __webpack_public_path__ + "static/media/cq_oggi_option.fcdb835f.svg";